import { render, staticRenderFns } from "./ManifestsTableMobile.vue?vue&type=template&id=7a2a69a2&scoped=true"
import script from "./ManifestsTableMobile.vue?vue&type=script&lang=js"
export * from "./ManifestsTableMobile.vue?vue&type=script&lang=js"
import style0 from "./ManifestsTableMobile.vue?vue&type=style&index=0&id=7a2a69a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2a69a2",
  null
  
)

export default component.exports